// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-xPlTh";
var _3 = "title-223oI";
var _4 = "content-1bzEa";
var _5 = "text-XuAWa";
var _6 = "footer-1-S_B";
var _7 = "types-dOB2d";
export { _1 as "__esModule", _2 as "root", _3 as "title", _4 as "content", _5 as "text", _6 as "footer", _7 as "types" }
export default { "__esModule": _1, "root": _2, "title": _3, "content": _4, "text": _5, "footer": _6, "types": _7 }
